import { render, staticRenderFns } from "./AscErrorTypeIcon.vue?vue&type=template&id=ed7c9034&"
import script from "./AscErrorTypeIcon.vue?vue&type=script&lang=js&"
export * from "./AscErrorTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports